import React from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../env";
import "./ForestTourismPromo.css";
import {
  FaTree,
  FaPaw,
  FaMountain,
  FaExternalLinkAlt,
} from "react-icons/fa";

const portals = [
  {
    id: "saranda_forest",
    title: "Saranda Forest Division",
    subtitle: "Asia's Largest Sal Forest",
    icon: <FaTree />,
    url: "https://www.sarandaforest.in/",
    className: "portal-saranda",
  },
  {
    id: "palamau_tiger_reserve",
    title: "Palamau Tiger Reserve",
    subtitle: "Wildlife & Safari",
    icon: <FaPaw />,
    url: "https://www.palamautigerreserve.in/",
    className: "portal-palamau",
  },
  {
    id: "dalma_wildlife",
    title: "Dalma Wildlife Sanctuary",
    subtitle: "Nature & Eco Tourism",
    icon: <FaMountain />,
    url: "https://www.dalmawildlife.com/",
    className: "portal-dalma",
  },
];

export default function ForestTourismPromo() {
  const handlePortalClick = (portalId) => {
    axios
      .post(`${REACT_APP_API_URL}/api/visitor/portal-click`, { portalId })
      .catch((err) => {
        console.error("Failed to track portal click:", err);
      });
  };

  return (
    <section className="forest-section">
      <div className="container">

        <div className="text-center mb-5">
          <span className="forest-tag">
            Official Forest Department Portals
          </span>

          <h2 className="forest-heading">
            Explore Jharkhand's Forest Tourism
          </h2>

          <p className="forest-subheading">
            Explore Jharkhand's iconic forests, wildlife sanctuaries, and tiger reserves through the official Forest Department tourism portals.
          </p>
        </div>

        <div className="forest-stage">

          {portals.map((portal) => (
            <a
              key={portal.title}
              href={portal.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`forest-portal ${portal.className}`}
              onClick={() => handlePortalClick(portal.id)}
            >
              <div className="portal-icon">
                {portal.icon}
              </div>

              <div className="portal-info">
                <h2 className="portal-title">{portal.title}</h2>
                <span>{portal.subtitle}</span>
              </div>

              <FaExternalLinkAlt className="portal-arrow" />
            </a>
          ))}

        </div>

      </div>
    </section>
  );
}